import React from 'react';
import Actions from 'projects/components/list/ProjectsActions';
import { translate } from 'react-i18next';
import { formatMoney } from 'accounting-js';

const ProjectsListRow = ({ company, subcompany, permissions, project, t, handleToggle }) => {
  return (
    <tr>
      <td>{project.key}</td>
      <td>{project.name}</td>
      <td>{formatMoney(project.amount)}</td>
      <td className="text-center">{t(project.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          company={company}
          project={project}
          handleToggle={handleToggle}
          permissions={permissions}
          subcompany={subcompany}
        />
      </td>
    </tr>
  );
};

export default translate()(ProjectsListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/ProjectsListRow.js